<template>

  <div class="wallets-service" v-if="load">
    <div class="col-wallets">
      <wallet-header v-model="date"> </wallet-header>
      <h2 class="main-title">Залишки по картках </h2>
      <div class="main-header flex-justify" >
        <div class="inner-addon">
        </div>
        <div class="header-right">
          <div class="select" >
            <select v-model="limitStatus">
              <option value=10>10</option>
              <option value=20>20</option>
              <option value=40>40</option>
              <option value=50>50</option>
              <option value=100>100</option>
            </select>
          </div>
        </div>
      </div>
      <section class="limit">
        <header>
          <div class="col-td">Картка/Тримач</div>
          <div class="col-td">ЗАЛИШОК (₴)</div>
          <div class="col-td"></div>
        </header>
        <div class="table-row first-row">
          <div class="col-td desktop">ВСЬОГО</div>
          <div class="col-td desktop">{{data.total.totalSum}}</div>
          <div class="col-td desktop"></div>
        </div>
        <div class="table-row" @click.prevent="cartNum=[r.cardNo]" v-for="(r,i) in data.data" :key="i" >
          <div class="col-td desktop" style="width: 65%" >{{r.cardNo}} - {{r.description}}</div>
          <div class="col-td desktop" style="width: 25%" >{{r.summa}}</div>
          <div class="col-td desktop">
            <div class="checkbox" >
              <input type="checkbox" class="custom-checkbox" v-model="cartNum" :id="'category_' + r.cardNo" :value="r.cardNo"  />
              <label :for="'category_' + r.cardNo"></label>
            </div>
          </div>
        </div>
      </section>
      <div class="container">

        <paginate v-if="data.total.totalCount/limitStatus > 1"
                  :page-count="Math.ceil(data.total.totalCount/limitStatus)"
                  :click-handler="changePageStatus"
                  :page-range="4"
                  :margin-pages="4"
                  :initial-page="pageStatus"
                  :prev-text="'Попередня'"
                  :next-text="'Наступна'"
                  :container-class="'pagination'">
        </paginate>
        <div class="pagination-info">
          Показується з {{pageStatus * limitStatus - limitStatus + 1}} по {{data.pageTotal.countOnPage === Number(limitStatus) ? pageStatus * limitStatus :  data.total.totalCount}} із {{ data.total.totalCount }}
        </div>
      </div>
      <div>
        <br>
        <button @click="walletsDownload">Скачать Exel 1С формат</button>
      </div>

    </div>
    <div class="col-wallets">
      <h2 class="main-title">Дані поповнення  {{cartNum[0]}}</h2>
      <div class="">
        <span class="text">Період з:</span>
        <div class="period">
          <div class="right-inner-addon">
            <date-picker  v-model="dateCart" format="DD.MM.YYYY" range :lang="lang" :disabled-date="disabledFilterDate"></date-picker>
          </div>
        </div>
      </div>
      <br>
      <div class="main-header flex-justify" >
        <div class="inner-addon">
        </div>
        <div class="header-right">
          <div class="select" >
            <select v-model="limitPay">
              <option value=10>10</option>
              <option value=20>20</option>
              <option value=40>40</option>
              <option value=50>50</option>
              <option value=100>100</option>
            </select>
          </div>
        </div>
      </div>
      <section class="limit">
        <header>
          <div class="col-td">Дата</div>
          <div class="col-td">Сумма (₴)</div>
          <div class="col-td">Вид Операції</div>
        </header>
        <div class="table-row"  v-for="(r,i) in pays.data" :key="i" >
          <div class="col-td desktop" style="width: 20%" >{{r.dt | formatDate}}</div>
          <div class="col-td desktop" style="width: 15%" >{{r.summa}}</div>
          <div class="col-td desktop">{{r.codeOp===""? "Online" : r.codeOp }}</div>
        </div>
      </section>
      <div class="container" v-if="pays.total">
        <paginate v-if="pays.total.totalCount/limitPay > 1"
                  :page-count="Math.ceil(pays.total.totalCount/limitPay)"
                  :click-handler="changePagePay"
                  :page-range="2"
                  :initial-page="pagePay"
                  :prev-text="'Попередня'"
                  :next-text="'Наступна'"
                  :container-class="'pagination'">
        </paginate>
        <div class="pagination-info">
          Показується з {{pagePay * limitPay - limitPay + 1}} по {{pays.pageTotal.countOnPage === Number(limitPay) ? pagePay * limitPay : pays.total.totalCount}} із {{pays.total.totalCount}}
        </div>
      </div>
    </div>
  </div>
</template>
<style>
.wallets-service {
  display: flex;
  /* flex-direction: column; */
  justify-content: space-between;
  width: 80%;
  align-self: center;
  justify-self: center;
}
.col-wallets {
  display: flex;
  flex-direction: column;

}
.col-wallets:first-child {
  width: 40%;
}
.col-wallets:last-child {
  width: 60%;
  background: rgba(229, 229, 229, 0.2);
  margin-left: 50px;
  padding: 25px;
}
pre {
  background: #4d3252;
  color: #FFFFFF;
}
</style>
<script>
    import Paginate from "vuejs-paginate";
    import moment from "moment";
    import WalletHeader from "../components/WalletHeader";
    import DatePicker from "vue2-datepicker";
    import qs from "qs";
    // import qs from "qs";

    export default {
      name: 'DigitalWallets',
      components: {
        WalletHeader,
        Paginate,
        DatePicker
      },
      created() {
        this.getData()
      },
      watch: {
        date: function () {
          this.load = false
          this.getData()
        },
        pageStatus: function () {
          // this.load = false
          this.getData()
        },
        limitStatus: function () {
          // this.load = false
          this.getData()
          this.pageStatus = 1
        },
        dateCart: function () {
          // this.load = false
          this.pagePay =1
          this.getPays()
        },
        pagePay: function () {
          // this.load = false
          this.getPays()
        },
        limitPay: function () {
          // this.load = false
          this.getPays()
          this.pagePay = 1
        },
        cartNum: function () {
          this.pagePay =1
          this.getPays()
        }
      },
      data() {
        return {
          load: false,
          data: [],
          pays: [],
          balance: [],
          date:  new Date(),
          dateCart: [new Date(moment(this.date).format('YYYY, MM, 01') ), new Date(moment(this.date).format('YYYY, MM, DD') )],
          pageStatus: 1,
          limitStatus: 10,
          pagePay: 1,
          limitPay: 10,
          cartNum: [],
          lang: {
            monthFormat: 'MMMM'
          },
        }
      },
      methods: {
        walletsDownload: function () {

          this.axios.get('/userservice/v1/Card/digital-wallets-download', {params:
                {onDate: moment(this.date).format('YYYY-MM-DD') + ' 00:00:00',},
            responseType: 'blob'}
          )
              .then(( data ) => {
                const file = data.data
                const downloadUrl = window.URL.createObjectURL(new Blob([file]));

                const link = document.createElement('a');

                link.href = downloadUrl;

                link.setAttribute('download', "ЕГ на " + moment(this.date).format('DD-MM-YYYY')  + '.xlsx'); //any other extension
                document.body.appendChild(link);

                link.click();

                link.remove();

              })
              .catch(error => {
                if (error.response && error.response.status === 401) {
                  this.$store.dispatch("logout")
                } else {
                  console.log(error);
                  this.errored = true;
                }
              })
        },
        disabledFilterDate: function (date){
          return date > this.date
        },
        changePageStatus: function (pageNum) {
           this.pageStatus = pageNum
        },
        changePagePay: function (pageNum) {
          this.pagePay = pageNum
        },
        getPays: function (){
          if (this.cartNum.length > 0) {
            this.axios.get('/userservice/v1/User/card-additions', {params: {begDate: moment(this.dateCart[0]).format('YYYY-MM-DD') + ' 00:00:00', endDate: moment(this.dateCart[1]).format('YYYY-MM-DD') + ' 23:59:59', page: this.pagePay, top: this.limitPay, cardNoList: this.cartNum }, paramsSerializer: params => {return qs.stringify(params)}})
                .then(
                    (pays) => {
                      this.pays = pays.data
                    })
                .catch(error => {
                  console.log('error_get_pays');
                  console.log(error);
                  this.errored = true;
                })
            // .finally(() => (
            //     this.load = true)
            // )
          }
        },
        getData: function (){
              this.axios.get('/userservice/v1/Card/card-status', {params: {onDate: moment(this.date).format('YYYY-MM-DD') + ' 00:00:00', page: this.pageStatus, top: this.limitStatus }})
            .then(
                (cardStatus) => {
                 this.data = cardStatus.data
                })
                .catch(error => {
                  console.log('error_get_data');
                  console.log(error);
                  this.errored = true;
                })
                .finally(() => (
                    this.load = true)
                )
          }
        },
      }
</script>